/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePalAuthorizationRequest
 */
export interface CreatePalAuthorizationRequest {
    /**
     * PAL auth integration ID (required if is_non_submission_flow is false)
     * @type {string}
     * @memberof CreatePalAuthorizationRequest
     */
    pal_auth_integration_id?: string;
    /**
     * Whether this is a non-submission flow
     * @type {boolean}
     * @memberof CreatePalAuthorizationRequest
     */
    is_non_submission_flow?: boolean;
}

/**
 * Check if a given object implements the CreatePalAuthorizationRequest interface.
 */
export function instanceOfCreatePalAuthorizationRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreatePalAuthorizationRequestFromJSON(json: any): CreatePalAuthorizationRequest {
    return CreatePalAuthorizationRequestFromJSONTyped(json, false);
}

export function CreatePalAuthorizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalAuthorizationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pal_auth_integration_id': !exists(json, 'pal_auth_integration_id') ? undefined : json['pal_auth_integration_id'],
        'is_non_submission_flow': !exists(json, 'is_non_submission_flow') ? undefined : json['is_non_submission_flow'],
    };
}

export function CreatePalAuthorizationRequestToJSON(value?: CreatePalAuthorizationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pal_auth_integration_id': value.pal_auth_integration_id,
        'is_non_submission_flow': value.is_non_submission_flow,
    };
}

